"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractiveChatMessages = void 0;
var _react = _interopRequireDefault(require("react"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = require("prop-types");
var _Messages = require("./components/Messages");
var _MessageInput = require("./components/MessageInput");
var _InteractiveChatMessages = require("./InteractiveChatMessages.styled");
var _DropdownMenu = _interopRequireDefault(require("./components/DropdownMenu"));
var InteractiveChatMessages = exports.InteractiveChatMessages = function InteractiveChatMessages(_ref) {
  var messages = _ref.messages,
    loadMore = _ref.loadMore,
    onInput = _ref.onInput,
    _ref$isChatEnabled = _ref.isChatEnabled,
    isChatEnabled = _ref$isChatEnabled === void 0 ? true : _ref$isChatEnabled,
    _ref$isAdmin = _ref.isAdmin,
    isAdmin = _ref$isAdmin === void 0 ? false : _ref$isAdmin,
    onToggle = _ref.onToggle,
    inputMarginBottom = _ref.inputMarginBottom,
    clearMessages = _ref.clearMessages;
  var title = isAdmin ? 'Chat' : 'Live chat';
  return _react["default"].createElement(_InteractiveChatMessages.Wrapper, null, _react["default"].createElement(_InteractiveChatMessages.TitleWrapper, null, _react["default"].createElement(_InteractiveChatMessages.Title, null, title), isAdmin && _react["default"].createElement(_DropdownMenu["default"], {
    title: "chat",
    enabled: isChatEnabled,
    onToggle: onToggle,
    onClear: clearMessages
  })), !isChatEnabled && _react["default"].createElement(_InteractiveChatMessages.DisabledText, null, "Chat is disabled, click the toggle to enable chat for this broadcast."), isChatEnabled ? _react["default"].createElement(_Messages.Messages, {
    messages: messages,
    loadMore: loadMore
  }) : _react["default"].createElement(_InteractiveChatMessages.EmptyWrapper, null, _react["default"].createElement(_InteractiveChatMessages.CommentIconsWrapper, null, _react["default"].createElement(_InteractiveChatMessages.CommentIcon, {
    icon: _freeSolidSvgIcons.faComment
  }), _react["default"].createElement(_InteractiveChatMessages.CommentIconInverted, {
    icon: _freeSolidSvgIcons.faComment
  }))), isChatEnabled && _react["default"].createElement(_MessageInput.MessageInput, {
    placeholder: "Send a message...",
    onInput: onInput,
    inputMarginBottom: inputMarginBottom
  }));
};
InteractiveChatMessages.propTypes = {
  messages: _propTypes.array,
  loadMore: _propTypes.func,
  onInput: _propTypes.func,
  isChatEnabled: _propTypes.bool,
  isAdmin: _propTypes.bool,
  onToggle: _propTypes.func,
  inputMarginBottom: _propTypes.string
};